const VERSION = '2.0.17b'
export default VERSION
